var _line, _line2, _line3, _line4, _line5, _polyline, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "article",
    viewBox: "0 0 640 640",
    fill: "none",
    stroke: "#666",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 93.51,
    y1: 288.96,
    x2: 336.39,
    y2: 443.89
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 256.25,
    y1: 178.26,
    x2: 483.11,
    y2: 322.96
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 342.85,
    y1: 293.11,
    x2: 439.99,
    y2: 355.07
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 309.95,
    y1: 320,
    x2: 407.09,
    y2: 381.96
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 271.67,
    y1: 349.02,
    x2: 368.81,
    y2: 410.98
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "286.3,291.64 316.47,270.56 220.6,208.65 135.44,261.55 233.78,324.19 258.32,309.07 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 30,
    d: "M347.52,559.68c0,0-218.88-130.8-298.56-189.12c-19.08-13.97-23.75-42.94-24.53-66.58c-0.77-23.23,7.19-45.13,22.85-62.3C89.72,195.12,254.4,102.72,254.4,102.72l361.31,224.07l-196.49,124.8c-4.28,2.72-7.93,6.33-10.7,10.58c-11,16.87-29.73,58.2-22.61,84.07c5.5,19.97,23.04,13.44,23.04,13.44s116.13-63.97,192-116.16c33.84-23.28,0-49.92,0-49.92c-62.4,37.44-114.24,72-176.64,109.44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.df518cde4825d9fffc9995c136e46017.svg";
export { ForwardRef as ReactComponent };